import { render, staticRenderFns } from "./CompromisLogo.vue?vue&type=template&id=ddde2acc&scoped=true&"
import script from "./CompromisLogo.vue?vue&type=script&lang=js&"
export * from "./CompromisLogo.vue?vue&type=script&lang=js&"
import style0 from "./CompromisLogo.vue?vue&type=style&index=0&id=ddde2acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddde2acc",
  null
  
)

export default component.exports